import { Injectable } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { filter, map, startWith, take, takeUntil, tap } from 'rxjs';

import { FiltersService } from '../filters.service';
import { AppListenerService, currentLang, filterQueryStringKey, getWindowRef } from '@hiptraveler/common';

function isSearchRoute(url: string): boolean {
  return [
    `/${currentLang()}/search`,
    `/${currentLang()}/experiences`,
    `/${currentLang()}/thingstodo`,
    `/${currentLang()}/hotels`,
    `/${currentLang()}/foodanddrink`,
    `/${currentLang()}/community`
  ].some((path: string) => url.includes(path));
}

@Injectable()
export class FiltersValueObserverService {

  constructor(
    private router: Router,
    private appListener: AppListenerService,
    private service: FiltersService
  ) { }

  observe(): void {

    this.service.subscription$.asObservable().pipe(take(1)).subscribe(() => {
    
      const currentUrl = this.router.url;
      const previousUrl = this.appListener.previousUrl;
      
      if (isSearchRoute(previousUrl) && currentUrl.includes(`/${currentLang()}/profile/`)) {
        const filterQuery = getWindowRef()[filterQueryStringKey];
        const queries = new URLSearchParams(filterQuery ?? '');
        queries.delete('keyword');
        getWindowRef()[filterQueryStringKey] = queries.toString();
      }
    });

    this.router.events.pipe(
      filter((event: Event): event is NavigationEnd => event instanceof NavigationEnd),
      map(e => e.url),
      startWith(this.router.url),
      tap((currentUrl: string) => {
        
        const previousUrl = this.appListener.previousUrl;

        if (isSearchRoute(previousUrl) && isSearchRoute(currentUrl)) {
          this.service.form.patchValue({ query: '' });
        }
      }),
      takeUntil(this.service.subscription$)
    ).subscribe();
  }

}
